import { render, staticRenderFns } from "./qlhTableColumn.vue?vue&type=template&id=6331efbe&"
import script from "./qlhTableColumn.vue?vue&type=script&lang=js&"
export * from "./qlhTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports